<template>
  <div class="falcon-chart-container">
    <div class="label">{{ progress }}%</div>
    <div class="falcon-chart" ref="chart">

    </div>
  </div>

</template>

<script>
import echarts from "echarts";

export default {
  name: "ProgressGraph.vue",
  props: ['progress',],
  mounted() {
    this.progress = Math.floor(this.progress)
    let option = {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        show: false,
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['65%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: false,
              fontSize: '40',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: [
            {
              value: this.progress,
              name: '',
              itemStyle: {
                color: '#1EBCBE'
              }
            },
            {
              value: 100 - this.progress,
              name: '',
              itemStyle: {
                color: '#D3D5D8'
              },
              formatter: ''
            },
          ]
        }
      ]
    };

    var myChart = echarts.init(this.$refs['chart'], null, {
      renderer: 'svg',
      // width : "50px",
      // height : "50px",
    });
    myChart.setOption(option);
  },
  updated() {
    this.progress = Math.floor(this.progress)
  }
}
</script>

<style lang="scss" scoped>
.falcon-chart-container {
  position: relative;
  width: 100%;
  height: 100px;

  .label {
    position: absolute;
    top: 40px;
    left: 0;
    right: 0;
    text-align: center;
  }
}

.falcon-chart {
  width: 100%;
  height: 100px;
}
</style>
